import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect(){
    // Find all headings inside this.element and add ids if missing
    const headings = Array.from(this.element.querySelectorAll("h1, h2, h3, h4, h5, h6")).map((el, idx) => {
      if (!el.id) {
        el.id = `heading-${idx + 1}`
      }
      return { id: el.id, text: el.textContent, tag: el.tagName.toLowerCase() }
    })
    // Dispatch event to article-headings controller
    const event = new CustomEvent("article:headings", {
      detail: { headings },
      bubbles: true
    })

    setTimeout(() => {
        this.element.dispatchEvent(event)
    }, 10);
  }

  scroll(e){
    const headings = Array.from(this.element.querySelectorAll("h1, h2, h3, h4, h5, h6"));
    let currentId = null;
    const scrollTop = window.scrollY || window.pageYOffset;
    const scrollPaddingTop = parseInt(getComputedStyle(document.documentElement).scrollPaddingTop) || 0;
    const offset = 10 + scrollPaddingTop; // px from top to consider as "current"

    for (let i = 0; i < headings.length; i++) {
      const rect = headings[i].getBoundingClientRect();
      if (rect.top + window.scrollY - offset <= scrollTop) {
        currentId = headings[i].id;
      } else {
        break;
      }
    }

    const height = $(this.element).height();
    const position = $(this.element).position().top;
    const scrolled = (scrollTop / (position + height)) * 100;
    const event = new CustomEvent('updateProgress', { detail: { progress: scrolled, currentHeadingId: currentId }});
    window.dispatchEvent(event);
  }
}
